import { Search } from 'lucide-react';

interface NavigationSearchProps {
  onOpenSearch: () => void;
}

export function NavigationSearch({ onOpenSearch }: NavigationSearchProps) {
  return (
    <div className="border-b border-gray-200 px-3 py-2">
      <button
        type="button"
        onClick={onOpenSearch}
        className="flex w-full items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-left text-sm text-slate-600 transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1"
        aria-label="Search pages, actions, and records"
      >
        <Search className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="min-w-0 flex-1 truncate">Search pages &amp; actions</span>
        <kbd className="rounded border border-slate-200 bg-white px-1.5 py-0.5 text-[10px] font-semibold text-slate-500">
          /
        </kbd>
      </button>
    </div>
  );
}
